if (!customElements.get('ani-packaging-carousel')) {
  customElements.define('ani-packaging-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-pack-slide]')];
      this.dots = [...this.querySelectorAll('[data-pack-dot]')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.show = index => {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide,i) => slide.hidden = i !== this.index);
        this.dots.forEach((dot,i) => dot.setAttribute('aria-current',String(i === this.index)));
      };
      const select = index => { this.stop(); this.show(index); };
      this.querySelector('[data-pack-prev]').addEventListener('click',()=>select(this.index-1),options);
      this.querySelector('[data-pack-next]').addEventListener('click',()=>select(this.index+1),options);
      this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>select(i),options));
      this.addEventListener('mouseenter',()=>this.stop(),options);
      this.addEventListener('mouseleave',()=>this.start(),options);
      this.addEventListener('focusin',()=>this.stop(),options);
      this.addEventListener('focusout',()=>this.start(),options);
      document.addEventListener('visibilitychange',()=>document.hidden?this.stop():this.start(),options);
      this.start();
    }
    start() {
      this.stop();
      if (document.hidden || this.matches(':hover') || this.contains(document.activeElement) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(()=>this.show(this.index+1),4500);
    }
    stop() { clearInterval(this.timer); }
    disconnectedCallback() { this.stop(); this.abort?.abort(); }
  });
}
